import { BaseResponse } from './base.response';
import { Country } from '../models';

export class CountriesResponse extends BaseResponse {

  public countries: Country[];

}
